import { ApiFormattedResponse } from "@models/api_formatted_response"
import {
  MobileAppVersionCheck,
  MobileAppVersionConfig,
  MobilePlatform,
  UpdateMobileAppVersionConfigInput
} from "@models/mobile_app_version"
import { mutate, query } from "@utils/graphql"
import updateMobileAppVersionConfigDoc from "__generated__/queries/mutations/updateMobileAppVersionConfig"
import getMobileAppVersionDoc from "__generated__/queries/queries/getMobileAppVersion"
import getMobileAppVersionConfigsDoc from "__generated__/queries/queries/getMobileAppVersionConfigs"

export async function getMobileAppVersionConfigs(): Promise<
  ApiFormattedResponse<MobileAppVersionConfig[]>
> {
  const response = await query<{
    getMobileAppVersionConfigs?: { data: MobileAppVersionConfig[] }
  }>({
    query: getMobileAppVersionConfigsDoc,
    fetchPolicy: "network-only"
  })

  if (!response.isSuccess) return { ...response, data: undefined }
  return {
    isSuccess: true,
    data: response.data?.getMobileAppVersionConfigs?.data ?? []
  }
}

export async function updateMobileAppVersionConfig(
  input: UpdateMobileAppVersionConfigInput
): Promise<ApiFormattedResponse<MobileAppVersionConfig>> {
  const response = await mutate<{
    updateMobileAppVersionConfig?: { data: MobileAppVersionConfig }
  }>({
    mutation: updateMobileAppVersionConfigDoc,
    variables: { input }
  })

  if (!response.isSuccess) return { ...response, data: undefined }
  return {
    isSuccess: true,
    data: response.data?.updateMobileAppVersionConfig?.data
  }
}

/**
 * Calls the PUBLIC mobile query so staff can see exactly what a device on a given
 * version would get. The admin token + origin still produce a valid context and
 * the resolver asserts nothing, so this works unchanged from the panel — and it
 * exercises the real code path rather than re-implementing the verdict here.
 */
export async function previewMobileAppVersion(params: {
  platform: MobilePlatform
  currentVersion: string
}): Promise<ApiFormattedResponse<MobileAppVersionCheck>> {
  const response = await query<{
    getMobileAppVersion?: { data: MobileAppVersionCheck }
  }>({
    query: getMobileAppVersionDoc,
    fetchPolicy: "network-only",
    variables: { input: params }
  })

  if (!response.isSuccess) return { ...response, data: undefined }
  return { isSuccess: true, data: response.data?.getMobileAppVersion?.data }
}
